// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__D3U9k","centerAlignLabel":"checkbox_centerAlignLabel__8D_zU","label":"checkbox_label__EhAji","input":"checkbox_input__enrEW"};